import { useQuery } from 'react-query';
import { dsoCartService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

interface UseRetrieveDsoDiscountsOptions {
  enabled?: boolean;
}

/**
 * Fetches all DSO discounts from /dso/storefront/discounts endpoint.
 * Currently includes bulk discounts, but extensible for future discount types.
 *
 * Data is cached indefinitely (staleTime: Infinity) since discount configurations
 * are managed externally and change infrequently.
 *
 * Usage:
 * const { data: discounts, isLoading } = useRetrieveDsoDiscounts();
 *
 * To filter by SKU:
 * const cartSkus = cart.lineItems.map(item => item.sku);
 * const relevantDiscounts = discounts?.bulkDiscountProducts.filter(
 *   product => cartSkus.includes(product.sku)
 * );
 */
export const useRetrieveDsoDiscounts = (config?: { enabled?: boolean }) => {
  return useQuery(
    ServerStateKeysEnum.dsoDiscounts,
    () => dsoCartService.getDiscounts(),
    {
      staleTime: Infinity,
      enabled: config?.enabled ?? true,
    }
  );
};
